export const HITS_TYPES = {
  VIDEO: 'Videos',
  PATHWAY: 'Pathways',
  NEWS: 'Insights',
  GLOSSARY: 'Glossary',
};

export const HITS_TYPES_BY_URL = {
  search: '',
  videos: HITS_TYPES.VIDEO,
  pathways: HITS_TYPES.PATHWAY,
  insights: HITS_TYPES.NEWS,
  glossary: HITS_TYPES.GLOSSARY,
};

export const DEFAULT_URL = '/discover';

export const GLOBAL_TENANT = 'GLOBAL';

export const LIST_VIEW = 'list';
export const GRID_VIEW = 'grid';

export const HEADER_IMG_SRC_SET = [
  { width: 500, quality: 80 },
  { width: 800, quality: 80 },
  { width: 1100, quality: 80 },
  { width: 1200, quality: 80 },
  { width: 1920, quality: 80 },
];

export enum PATHWAY_ACTIONS {
  CONTINUE_WATCHING = 'continue_watching',
  TAKE_TEST = 'take_test',
  WATCH_AGAIN = 'watch_again',
  PASSED_TEST = 'passed_test',
  WATCH_NEW_CONTENT = 'watch_new_content',
}

export const calculatePathwayStatus = (
  watchedVideos: number,
  totalVideos: number,
  hash?: string | null,
  testId?: number | null,
): PATHWAY_ACTIONS => {
  const watchedAllVideos = watchedVideos === totalVideos;
  if (hash && watchedAllVideos) {
    return PATHWAY_ACTIONS.PASSED_TEST;
  } else if (hash && !watchedAllVideos) {
    return PATHWAY_ACTIONS.WATCH_NEW_CONTENT;
  } else if (testId && watchedAllVideos) {
    return PATHWAY_ACTIONS.TAKE_TEST;
  } else if (watchedAllVideos) {
    return PATHWAY_ACTIONS.WATCH_AGAIN;
  } else {
    return PATHWAY_ACTIONS.CONTINUE_WATCHING;
  }
};

export const DURATION_FILTER = 'duration_interval';
export const DURATION_FILTER_ORDER = [
  '0 - 15 minutes',
  '15 - 60 minutes',
  '1 - 2 hours',
  '3 - 4 hours',
  '4 hours +',
];
